<script>
  import { faPlay }  from '@fortawesome/free-solid-svg-icons/faPlay'
  import { faPause } from '@fortawesome/free-solid-svg-icons/faPause'
  import Icon        from 'fa-svelte'

  export let paused  = true
  export let waiting = true

  const toggle = () => {
    if (!waiting) {
      paused = !paused
    }
  }
</script>

<style lang="scss">
  .button {
    position: absolute;
    bottom: calc(50% - 25px);
    left: -100px;
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 50px;
    height: 50px;
    background: transparentize($pink, 0.2);
    border-radius: 50%;
    box-shadow: 0px 0px 25px 3px transparentize($pink, 0.2);
    cursor: pointer;

    &:before {
      position: absolute;
      top: -33.33%;
      left: -33.33%;
      width: 150%;
      height: 150%;
      background: none;
      border: 5px solid transparentize($white, 0.2);
      border-radius: 50%;
      opacity: 1;
      animation: pulsate 2s;
      animation-timing-function: steps;
      animation-delay: 0s;
      animation-iteration-count: infinite;
      animation-direction: forwards;
      content: '';

      @keyframes pulsate {
        0% {
          box-shadow: inset 0px 0px 25px 3px rgba(255, 255, 255, 0.75),
            0px 0px 25px 10px rgba(255, 255, 255, 0.75);
          transform: scale(0.6);
          opacity: 1;
        }
        100% {
          box-shadow: none;
          transform: scale(1);
          opacity: 0;
        }
      }
    }

    &.paused {
      &:before {
        visibility: hidden;
      }
    }

    .loader {
      width: 47px;
      height: 47px;
      border: 3px solid $pink;
      border-top: 3px solid $white;
      border-radius: 50%;
      animation: spin 2s linear infinite;
      position: absolute;
      top: 0;
      left: 0;
      transform: translateX(50%) translateX(50%);
    }

    @keyframes spin {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  }
</style>

<div on:click={toggle} class="button {paused ? 'paused' : ''}">
  {#if waiting}
    <div class="loader" />
  {:else}
    <Icon icon={paused ? faPlay : faPause} />
  {/if}
</div>
